import { useConstantValueInvariant } from "@contember/react-utils";
import { useState, useCallback, useEffect } from "react";
function useAccessorUpdateSubscription(getAccessor, withForceUpdate) {
  const [state, setState] = useState(() => ({
    accessor: getAccessor(),
    getAccessor
  }));
  useConstantValueInvariant(withForceUpdate, "useAccessorUpdateSubscription: cannot change the withForceUpdate value!");
  let accessor = state.accessor;
  if (state.getAccessor !== getAccessor) {
    setState({
      accessor: getAccessor(),
      getAccessor
    });
    accessor = getAccessor();
  }
  let forceUpdate = void 0;
  if (withForceUpdate) {
    forceUpdate = useCallback(() => {
      setState({
        accessor: getAccessor(),
        getAccessor
      });
    }, [getAccessor]);
  }
  useEffect(() => {
    let isStillSubscribed = true;
    const unsubscribe = getAccessor().addEventListener({ type: "update" }, (newAccessor) => {
      if (!isStillSubscribed) {
        return;
      }
      setState((prevState) => {
        if (prevState.getAccessor !== getAccessor || prevState.accessor === newAccessor) {
          return prevState;
        }
        return {
          accessor: newAccessor,
          getAccessor
        };
      });
    });
    return () => {
      isStillSubscribed = false;
      unsubscribe();
    };
  }, [getAccessor]);
  if (withForceUpdate && forceUpdate) {
    return [accessor, forceUpdate];
  }
  return accessor;
}
export {
  useAccessorUpdateSubscription
};
//# sourceMappingURL=useAccessorUpdateSubscription.js.map
